import { PlanAdvisorExperience, PlanAdvisorPoe, PlanSponsorPoe } from '../app/constants/navbar.constants';

export const Environment = {

    getHost(): string {
        const experience = (window as any).__experience;

        const poe = experience?.context?.pointOfEntry;

        if (poe) {
            if (poe === PlanSponsorPoe) {
                return experience.hosts?.planSponsorLegacyHost || (window as any).location.origin;
            } else if (poe === PlanAdvisorPoe) {
                return experience.hosts?.planAdvisorLegacyHost || (window as any).location.origin;
            } else {
                throw new Error(`Invalid point of entry: ${experience?.context?.pointOfEntry}`);
            }
        } else {
            return (window as any).location.origin;
        }
    },

    getReqId() {
        // eslint-disable-next-line
        return (<any>window).fsreqid;
    },

    getNavigationDataUrl(pageId: string, realm: string) {
        // eslint-disable-next-line
        if(realm.toLocaleLowerCase().startsWith(PlanAdvisorExperience)) {
            return this.getHost() +'/planadvisor/go/to/pages/'+pageId+'/layout';
        }
        return this.getHost() +'/plansponsor/go/to/pages/'+pageId+'/layout';
    },

    // The following methods are specifically used within the PlanSponsor navigation bar

    get recentlyViewedParticipantsDataUrl() {
        return this.getHost() + '/plansponsor/participantsearch/api/participants/recently-viewed';
    },

    get participantChosenUrl(): string {
        return this.getHost() + '/plansponsor/participantsearch/api/participant-chosen';
    },

    // Url to update preferences
    get updatePreferencesUrl(): string {
        return this.getHost() + '/plansponsor/participantsearch/api/preferences/';
    },

    // Url to get txn token
    get txnTokenUrl(): string {
        return this.getHost() + '/plansponsor/participantsearch/api/txntoken';
    },

    // participant search landing page
    get partSearchLanding(): string {
        return this.getHost() +'/plansponsor/go/to/partSearchLanding/#partSearchLanding';
    },

    // participant search options api
    get participantSearchOptionsDataUrl(): string {
        return this.getHost() +'/plansponsor/participantsearch/api/options?destinations=true&destPreference=false';
    }


};
